import AnalyticsDataViewer from './AnalyticsDataViewer'
import AnalyticsEventsDataViewer from './AnalyticsEventsDataViewer'
import AnalyticsQueryHandler from './AnalyticsQueryHandler'
import AnalyticsSupportDataViewer from './AnalyticsSupportDataViewer'

export default {
  install( molten ) {
    molten.addPlugin( 'DataViewer', AnalyticsSupportDataViewer )
    molten.addPlugin( 'DataViewer', AnalyticsDataViewer )
    molten.addPlugin( 'DataViewer', AnalyticsEventsDataViewer )
    molten.addPlugin( 'EventQueryOptionsHandler', AnalyticsQueryHandler )
  }
}
